module.exports = __webpack_public_path__ + "static/tpp-image07-911fa41181995592c442e8bb17844c89.jpg";